import React, { JSX } from "react";
import "./homeSection.css";

// Define the props type
interface SectionProps {
  image: string;
  title: string;
  text: string | (string | JSX.Element)[];
  reverse?: boolean; // optional
}

export default function Section({ image, title, text, reverse = false }: SectionProps) {
  return (
    <div className={`section ${reverse ? "reverse" : ""}`}>
      <div className="section-image">
        <img src={image} alt={title} />
      </div>
      <div className="section-content">
        <h2>{title}</h2>

        {Array.isArray(text)
          ? text.map((item, index) => <p key={index}>{item}</p>)
          : <p>{text}</p>
        }
      </div>
    </div>
  );
}
